/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';
import type { Wealthlane_CustomerService_Dtos_SupportContact_AlertSubscriptionTypeDto } from '../models/Wealthlane_CustomerService_Dtos_SupportContact_AlertSubscriptionTypeDto';
import type { Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto } from '../models/Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto';
import type { Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto } from '../models/Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SupportContactService {

    /**
     * @param companyId 
     * @returns Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppSupportContactSupportContactsByCompanyId(
companyId: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/support-contact/support-contacts-by-company-id/{companyId}',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_SupportContact_AlertSubscriptionTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppSupportContactActiveAlertSubscriptionTypes(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_SupportContact_AlertSubscriptionTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/support-contact/active-alert-subscription-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppSupportContactSaveSupportContacts(
requestBody?: Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/support-contact/save-support-contacts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
